// https://apto-api-specs.netlify.app/private/stargateapi#operation/load_signed_payload_key
export default {
	key_id: 'dummy_key_id',
	public_key: 'dummy_updated_public_key',
	name: 'dummy_updated_public_key_name',
	created: '2016-10-19T23:20:17.000Z',
};
